export const roleFormatMixin = {
  methods: {
    formatRole(role) {
      const translations = {
        MAIN_AUTHOR: 'Main Author',
        CO_AUTHOR: 'Coauthor',
        PROPOSAL_EDITOR: 'Proposal Editor',
        EXPERIMENTALIST: 'Experimentalist',
        EXPERIMENTALIST_UPPERCASE: 'Experimentalist',
        PRINCIPLE_INVESTIGATOR: 'Principle investigator',
        MAIN_PROPOSER: 'Main proposer',
      };

      const upperCaseRole = role.toUpperCase();
      return `${translations[upperCaseRole] || role}`;
    },
  },
};
